const doc = [({"en":({"js":({"admin":({"employee_prices":({"table":({"the_employee_price_was_deleted":"The employee prices were deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;